import { PRODUCT_IMAGE_URL, BLOG_IMAGE_PATH } from "../constants";

export const creatImageUrlFromName = (name, size = 1) => `${PRODUCT_IMAGE_URL}${name}-${size}.jpg`;
export const createBlogMainImageUrl = (image) => `${BLOG_IMAGE_PATH}huvudbild/${image}`;
export const preloadImageUrl = (url) => {
    if (typeof window !== "undefined") {
        const i = new Image();
        setTimeout(() => (i.src = url), 0);
    }
};
